import { FlexBox, Loader, LoaderType } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'

export const ReaderSummaryLoader = () => {
  const { colors } = useTheme()
  const [theme, isProfileView] = useStats((s) => [s.theme, s.isProfileView])

  return (
    <FlexBox
      className={css`
        width: 100%;
        height: 150px;
        position: relative;
        border-radius: 20px;
        background-color: ${isProfileView ? theme.primary : colors.uiWhite20};
        overflow: hidden;
      `}
      centerAll
    >
      <span
        className={css`
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: ${theme.primary};
          opacity: 0.2;
        `}
      />
      <Loader
        type={LoaderType.contained}
        className={css`
          position: relative;
        `}
        iconClass={css`
          svg {
            width: 60px !important;
            height: auto !important;
            path {
              fill: ${colors.uiWhite};
            }
          }
        `}
      />
    </FlexBox>
  )
}
